import { algoliasearch } from 'algoliasearch'

const algoliaAppId = import.meta.env.VITE_ALGOLIA_APP_ID
const algoliaSearchKey = import.meta.env.VITE_ALGOLIA_SEARCH_KEY
const algoliaIndexName = import.meta.env.VITE_ALGOLIA_CLIENTS_INDEX_NAME || 'clients'

if (!algoliaAppId || !algoliaSearchKey) {
    console.warn(
        'Algolia configuration is missing. Please set VITE_ALGOLIA_APP_ID and VITE_ALGOLIA_SEARCH_KEY environment variables.',
    )
}

export const algoliaClient = algoliaAppId && algoliaSearchKey ? algoliasearch(algoliaAppId, algoliaSearchKey) : null

export const clientsIndexName = algoliaIndexName
